var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"solo":"","rounded":"","clearable":"","prepend-inner-icon":"search","placeholder":_vm.placeholder,"value":_vm.modelValue},on:{"input":function($event){return _vm.onInput($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }